export class TouchButtons extends Phaser.GameObjects.Container {
  constructor(scene, playerCharacter) {
    super(scene, 0, 0);
    scene.add.existing(this);
    this.setScrollFactor(0);
    this._playerCharacter = playerCharacter;
    this.btnJump = scene.add.image(0, 125, 'graphics', 'btn_jump').setOrigin(0, 0.5);
    this.btnAttack = scene.add
      .image(
        this.btnJump.x + this.btnJump.width + 20,
        this.btnJump.y - 35,
        'graphics',
        'btn_attack'
      )
      .setOrigin(0, 0.5);
    this.btnSpecial = scene.add
      .image(
        this.btnAttack.x + this.btnAttack.width + 20,
        this.btnAttack.y - 35,
        'graphics',
        'btn_special'
      )
      .setOrigin(0, 0.5);

    this.btnJump.setScrollFactor(0);
    this.btnAttack.setScrollFactor(0);
    this.btnSpecial.setScrollFactor(0);
    this.add([this.btnSpecial, this.btnAttack, this.btnJump]);
  }

  enable() {
    if (!this._playerCharacter) return;
    this.btnJump.setInteractive({});
    this.btnJump.on('pointerdown', this._playerCharacter.jump, this._playerCharacter);
    this.btnAttack.setInteractive({});
    this.btnAttack.on('pointerdown', this._playerCharacter.attack, this._playerCharacter);
    this.btnSpecial.setInteractive({});
    this.btnSpecial.on('pointerdown', this._playerCharacter.special, this._playerCharacter);
  }

  disable() {
    if (!this._playerCharacter) return;
    this.btnSpecial.removeInteractive();
    this.btnAttack.removeInteractive();
    this.btnJump.removeInteractive();
    this.btnJump.off('pointerdown', this._playerCharacter.jump, this._playerCharacter);
    this.btnAttack.off('pointerdown', this._playerCharacter.attack, this._playerCharacter);
    this.btnSpecial.off('pointerdown', this._playerCharacter.special, this._playerCharacter);
  }

  get displayWidth() {
    return this.btnSpecial.x + this.btnSpecial.displayWidth;
  }

  get displayHeight() {
    return 200;
  }
}
